import { render, staticRenderFns } from "./ModalAgency.vue?vue&type=template&id=6b7ba23c"
import script from "./ModalAgency.vue?vue&type=script&lang=js"
export * from "./ModalAgency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports